import AddSvg from '@/common/assets/icons/add.svg?react';
import Button from '@/common/components/base/button/Button';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import MainLayout from '@/common/components/layouts/MainLayout';
import BodySubstitutionPartsList from '@/modules/adjusterReportModules/Insurer-information/components/expert/BodySubstitutionPartsList';
import { useNavigate } from 'react-router-dom';
import { Box } from 'styled-system/jsx';
import { token } from 'styled-system/tokens';
import { ADJUSTER_REPORT_BODY_DAMAGE_PATHS } from '@/modules/adjusterReportModules/adjusterReport/links/bodyDamage/bodyDamageLinks';

export default ({ isEditable = true }: { isEditable?: boolean }) => {
  return (
    <MainLayout title="بیمه گذار / کارشناسی" header="titleHeader">
      <BodySubstitutionPartsPage isEditable={isEditable} />
    </MainLayout>
  );
};

const BodySubstitutionPartsPage = ({
  isEditable = true,
}: {
  isEditable?: boolean;
}) => {
  const navigate = useNavigate();

  return (
    <Box pt={24}>
      <TitleDescription>لوازم تعویضی</TitleDescription>
      {isEditable && (
        <Button
          fullWidth
          mt={24}
          variant="outlined"
          color="success"
          onClick={() =>
            navigate(
              ADJUSTER_REPORT_BODY_DAMAGE_PATHS.INFORMATION.EXPERT
                .substitutionPartsForm,
            )
          }
        >
          <Box mx={12}>
            <AddSvg stroke={token('colors.green-2')} width={20} height={20} />
          </Box>
          افزودن قطعه
        </Button>
      )}
      <BodySubstitutionPartsList isEditable={isEditable} />
    </Box>
  );
};
